import { render, staticRenderFns } from "./ServiceChargeEdit.vue?vue&type=template&id=ff137634&scoped=true&"
import script from "./ServiceChargeEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeEdit.vue?vue&type=style&index=0&id=ff137634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff137634",
  null
  
)

export default component.exports